<div class="row">
    <div class="col">
        <a title="AIF" class="mx-1" (click)="onActionClick('aif', displayValue.data.id, '')" [ngClass]="{ disabled: !isLocked  }">
        @if(isAIFStarted){
            <img src="../../../assets/Krid/img/aif-filled.svg"/>
          }@else {
            <img  src="../../../assets/Krid/img/aif.svg"/>
          }
        </a>
    </div>
</div>